import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { Chip, Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";
import FilterBy from "./FilterBy";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple}!important;
  color: ${colors.purple}!important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple}!important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  campaigns,
  setPage,
  setSearchKey,
  loading,
  filterBy,
  setFilterBy,
}) {
  const navigate = useNavigate();
  let columns = [
    { name: "campaign_name", label: "Campaign Name" },
    { name: "platform_source", label: "Platform Source" },

    { name: "brand_name", label: "Brand Name" },

    { name: "agency_name", label: "Agency Name" },

    {
      name: "camapign_period",
      label: "Campaign Period",
    },

    { name: "request_status", label: "Request Status" },
    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "budget") {
      return row.min_budget + "-" + row.max_budget;
    }

    if (col.name === "camapign_period") {
      return (
        convertDate(row.start_duration) + " - " + convertDate(row.end_duration)
      );
    }

    if (col.name === "agency_name") {
      return row.brand?.agency ? (
        row.brand?.agency
      ) : (
        <span style={{ display: "flex", justifyContent: "center" }}>-</span>
      );
    }

    if (col.name === "request_status") {
      let color;
      let background;
      if (value === "REQUESTED" || value === "CREATED") {
        color = colors.warning;
        background = colors.lightWarning;
      }

      if (value === "ACCEPTED") {
        color = colors.success;
        background = colors.lightSuccess;
      }

      if (value === "PARTIAL_ACCEPTED") {
        color = colors.success;
        background = colors.lightSuccess;
      }

      if (value === "INITIATED") {
        color = colors.purple;
      }

      if (value === "OFFER_ACCEPTED") {
        color = colors.success;
        background = colors.lightSuccess;
      }

      if (value === "PARTIAL_REJECTED") {
        color = colors.error;
        background = colors.lightError;
      }

      if (
        value === "REJECTED" ||
        value === "Expired" ||
        value === "FAILED" ||
        value === "MISSED"
      ) {
        color = colors.error;
        background = colors.lightError;
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: background,
            color: color,
          }}
          label={value?.replace(/_/g, " ")}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Campaign">
            <Icon
              onClick={() =>
                navigate(
                  pages.superAdminCampaignDetails.route +
                    row.campaign_id +
                    "?brandID=" +
                    row.brand_id
                )
              }
            >
              <CgEye style={{ height: "20px", width: "20px" }} />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar
              setPage={setPage}
              setSearchKey={setSearchKey}
              filterBy={filterBy}
              setFilterBy={setFilterBy}
            />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={campaigns}
        />
      </Grid>
    </Grid>
  );

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }
}

export function ToolBar({ setPage, setSearchKey, filterBy, setFilterBy }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />

        <FilterBy
          filterBy={filterBy}
          setFilterBy={setFilterBy}
          setPage={setPage}
        />
      </div>
    </div>
  );
}
